import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface AddToCalendarIconProPlusProps extends SvgIconProps {}

export const AddToCalendarPlusIcon = (
  props: AddToCalendarIconProPlusProps,
): ReactElement => {
  return (
    <SvgIcon viewBox="0 0 24 25" {...props}>
      <mask
        id="mask0_73_2488"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_73_2488)">
        <path
          d="M17.5 22V19H14.5V18H17.5V15H18.5V18H21.5V19H18.5V22H17.5ZM5.6155 19.5C5.15517 19.5 4.77083 19.3459 4.4625 19.0375C4.15417 18.7292 4 18.3449 4 17.8845V7.11554C4 6.6552 4.15417 6.27087 4.4625 5.96254C4.77083 5.6542 5.15517 5.50004 5.6155 5.50004H7.3845V3.26929H8.4615V5.50004H13.6155V3.26929H14.6155V5.50004H16.3845C16.8448 5.50004 17.2292 5.6542 17.5375 5.96254C17.8458 6.27087 18 6.6552 18 7.11554V12.8308C17.8333 12.8193 17.6667 12.8135 17.5 12.8135C17.3333 12.8135 17.1667 12.8193 17 12.8308V11.1155H5V17.8845C5 18.0385 5.06408 18.1796 5.19225 18.3078C5.32042 18.436 5.4615 18.5 5.6155 18.5H12.2885C12.2885 18.6667 12.2943 18.8334 12.3058 19C12.3173 19.1667 12.3384 19.3334 12.3693 19.5H5.6155ZM5 10.1153H17V7.11554C17 6.96154 16.9359 6.82045 16.8077 6.69229C16.6796 6.56412 16.5385 6.50004 16.3845 6.50004H5.6155C5.4615 6.50004 5.32042 6.56412 5.19225 6.69229C5.06408 6.82045 5 6.96154 5 7.11554V10.1153Z"
          fill="#383838"
        />
      </g>
    </SvgIcon>
  );
};

export default AddToCalendarPlusIcon;
